import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-firmware-update-modal',
  templateUrl: './firmware-update-modal.component.html',
  styleUrls: ['./firmware-update-modal.component.scss'],
  standalone: false
})
export class FirmwareUpdateModalComponent {

  firmwareUrlControl = new FormControl('', [
    Validators.required,
    Validators.pattern(/\.epk$/i)
  ]);

  constructor(
    public dialogRef: MatDialogRef<FirmwareUpdateModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: FirmwareUpdateModalData
  ) {}

  getErrorMessage(): string {
    if (this.firmwareUrlControl.hasError('required')) {
      return 'Please enter a firmware file URL.';
    }
    if (this.firmwareUrlControl.hasError('pattern')) {
      return 'Please enter a valid firmware file URL ending in .epk.';
    }
    return '';
  }

  onCancel(): void {
    this.dialogRef.close(null);
  }

  onUpdate(): void {
    if (this.firmwareUrlControl.valid) {
      this.dialogRef.close({
        firmwareUrl: this.firmwareUrlControl.value
      });
    }
  }

  onViewInstructions(): void {
    // TODO: Implement navigation to full instructions
    // This could open a help page or external documentation
    window.open('https://help.risevision.com/firmware-update-instructions', '_blank');
  }
}

export interface FirmwareUpdateModalData {
  displayName?: string;
  isMultiple?: boolean;
}
